<template>
	<div v-if="$store.state.userStatus == 'on'" @click="switchStatus(value ? 0 : 1)" style="cursor: pointer;">
		<el-switch style="pointer-events: none;" v-model="value" active-color="#13ce66" inactive-color="#dcdfe6" :active-text="value ? '已开启接待' : '已停止接待'"></el-switch>
	</div>
</template>

<script>
export default {
	name: 'receptionStatus',
	data () {
		return {
			loading: false
		}
	},
	computed: {
		shopList () {
			return this.$store.state.shopList;
		},
		currentShop () {
			return this.$store.state.currentShop;
		},
		userInfo () {
			return this.$store.state.userInfo;
		},
		value () {
			return !!(this.$store.state.shopList.find(o => o.id == this.$store.state.currentShop.id) || {}).receptionStatus
		}
	},
	methods: {
		switchStatus(status) {
			var self = this
			var data = {
				customerId: self.userInfo.id,
				shopId: self.currentShop.id,
				receptionStatus: status
			}
			if (self.loading) {
				return
			}

			if (data.receptionStatus) {
				handle()
			} else {
				self.$confirm('你确定要暂停当前店铺的接待？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					handle()
				}).catch(() => {
				});
			}

			function handle() {
				self.loading = true
				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.setReceptionStatus', data).then(result => {
					self.loading = false
					if (!result.status) {
						self.$message.error('切换状态失败，失败原因：' + result.msg);
					} else {
						var arr = self.shopList.map(o => {
							if (o.id === data.shopId) {
								o.receptionStatus = data.receptionStatus
							}
							return o
						})
						self.$store.commit('changeShopList', arr);
					}
				}, response => {
					self.loading = false
					self.$message.error('切换状态失败，失败原因：网络繁忙');
				})
			}
		}
	}
}
</script>
<style lang="less" scoped>
	.icon {
		font-size: 22px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/pages/head/receptionStatus.vue